import { AnyAction } from 'redux';
import { GlobalEventDispatcher } from '../globalEventDispatcher';

export class GlobalPut {
  private static instance: GlobalPut;
  public globalEventDispatcherFunction: () => GlobalEventDispatcher;

  static getInstance(): GlobalPut {
    if (!this.instance) {
      this.instance = new GlobalPut();
    }

    return this.instance;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  put = (action: AnyAction): void => {
    const globalEventDispatcher =
      this.globalEventDispatcherFunction && this.globalEventDispatcherFunction();

    if (globalEventDispatcher) {
      try {
        globalEventDispatcher.dispatch(action);
      } catch {
        console.log('Cant dispatch global event: no global event dispatcher configured, ');
      }
    }
  };
}
